export const securityQuestions = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SECURITY_QUESTIONS':
      return action.securityQuestions;
    default:
      return state;
  }
};

export const getSecurityQuestions = (state) => state;
